import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { PackageInterest } from './package-interest';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PackageInterestService {
  constructor(private http: HttpClient) {}

  setInterestInPackagePublic(packageInterest: PackageInterest): Observable<any> {
    if (!packageInterest.accountGroupId) {
      return observableThrowError('Account Group Id required.');
    }
    return this.http.post(`/public/v1/interest-in-package/`, packageInterest);
  }
}
